import React, { useState } from "react";
import { Badge, Button, List, Space, Switch } from "antd";
import PageLoader from "./PageLoader";
import { gql, useQuery } from "@apollo/client";
import { Link } from "react-router-dom";
import prettyDateString from "../lib/prettyDateString";
import { usePermissions } from "../lib/usePermissions";

export const USERS_QUERY = gql`
  query users {
    users {
      id
      firstName
      lastName
      email
      calendarLink
      active
      createdAt
    }
  }
`;

function userTitle(user: any): string {
  return `${user.firstName} ${user.lastName}`;
}

const UserList: React.FC = () => {
  const [showInactive, setShowInactive] = useState(false);
  const { loading, error, data } = useQuery(USERS_QUERY);
  const { permissions } = usePermissions();

  if (loading)
    return <PageLoader style={{ display: "block", marginTop: 40 }} />;
  if (error) return <p>Error: {error.message}</p>;

  const allUsers: any[] = data?.users ?? [];
  const displayUsers = showInactive
    ? allUsers
    : allUsers.filter((u) => u.active);

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 16,
        }}
      >
        <Space>
          <Switch
            checked={showInactive}
            onChange={setShowInactive}
            size="small"
          />
          <span>Show inactive users</span>
        </Space>
        {permissions.has("users.manage") && (
          <Link to="/users/new">
            <Button type="primary">Create User</Button>
          </Link>
        )}
      </div>
      <List
        dataSource={displayUsers}
        renderItem={(user: any) => (
          <List.Item key={user.id}>
            <List.Item.Meta
              title={<Link to={`/users/${user.id}`}>{userTitle(user)}</Link>}
              description={user.email}
            />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                gap: 4,
              }}
            >
              <Badge
                status={user.active ? "success" : "default"}
                text={user.active ? "Active" : "Inactive"}
              />
              <span>{prettyDateString(user.createdAt)}</span>
            </div>
          </List.Item>
        )}
      />
    </>
  );
};

export default UserList;
